import { render, staticRenderFns } from "./AddVendor.vue?vue&type=template&id=b3d2be8a&scoped=true"
import script from "./AddVendor.vue?vue&type=script&lang=js"
export * from "./AddVendor.vue?vue&type=script&lang=js"
import style0 from "./AddVendor.vue?vue&type=style&index=0&id=b3d2be8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d2be8a",
  null
  
)

export default component.exports